import React, { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';
import { Button } from './ui/button';
import { Link, useLocation } from 'react-router-dom';

export const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const isActive = (path) => location.pathname === path;

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-lg py-3' : 'bg-white/95 backdrop-blur-sm py-4'
      }`}
    >
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between">
          <Link to="/" className="flex items-center space-x-3">
            <img
              src="https://customer-assets.emergentagent.com/job_c5e5208d-6c87-43b5-ba57-a4994d46a238/artifacts/ea49mu95_Logo%20Email%20Signature.png"
              alt="Custom Maids RVA"
              className="h-12 w-auto transition-transform duration-300 hover:scale-105"
            />
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center space-x-6">
            <Link
              to="/"
              className={`hover:text-[#0B7CB5] transition-colors duration-200 font-medium ${
                isActive('/') ? 'text-[#0B7CB5]' : 'text-gray-700'
              }`}
            >
              Home
            </Link>
            <Link
              to="/services"
              className={`hover:text-[#0B7CB5] transition-colors duration-200 font-medium ${
                isActive('/services') ? 'text-[#0B7CB5]' : 'text-gray-700'
              }`}
            >
              Services
            </Link>
            <Link
              to="/calculator"
              className={`hover:text-[#0B7CB5] transition-colors duration-200 font-medium ${
                isActive('/calculator') ? 'text-[#0B7CB5]' : 'text-gray-700'
              }`}
            >
              Estimate
            </Link>
            <Link
              to="/about"
              className={`hover:text-[#0B7CB5] transition-colors duration-200 font-medium ${
                isActive('/about') ? 'text-[#0B7CB5]' : 'text-gray-700'
              }`}
            >
              About
            </Link>
            <Link
              to="/faq"
              className={`hover:text-[#0B7CB5] transition-colors duration-200 font-medium ${
                isActive('/faq') ? 'text-[#0B7CB5]' : 'text-gray-700'
              }`}
            >
              FAQ
            </Link>
            <Link
              to="/careers"
              className={`hover:text-[#0B7CB5] transition-colors duration-200 font-medium ${
                isActive('/careers') ? 'text-[#0B7CB5]' : 'text-gray-700'
              }`}
            >
              Careers
            </Link>
            <Link
              to="/policies"
              className={`hover:text-[#0B7CB5] transition-colors duration-200 font-medium ${
                isActive('/policies') ? 'text-[#0B7CB5]' : 'text-gray-700'
              }`}
            >
              Policies
            </Link>
            <a 
              href="tel:+18045837000"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-colors h-9 px-4 py-2 bg-[#0B7CB5] hover:bg-[#095a87] text-white hover:shadow-lg no-underline"
              style={{ touchAction: 'manipulation', cursor: 'pointer', WebkitTapHighlightColor: 'rgba(11, 124, 181, 0.3)', zIndex: 100 }}
            >
              Call/Text Us
            </a>
          </nav>

          {/* Mobile Menu Button */}
          <button
            className="lg:hidden text-gray-700 hover:text-[#0B7CB5] transition-colors"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMobileMenuOpen && (
          <nav className="lg:hidden mt-4 pb-4 flex flex-col space-y-3 animate-in slide-in-from-top duration-200">
            <Link
              to="/"
              onClick={() => setIsMobileMenuOpen(false)}
              className={`hover:text-[#0B7CB5] transition-colors duration-200 font-medium text-left py-2 ${
                isActive('/') ? 'text-[#0B7CB5]' : 'text-gray-700'
              }`}
            >
              Home
            </Link>
            <Link
              to="/services"
              onClick={() => setIsMobileMenuOpen(false)}
              className={`hover:text-[#0B7CB5] transition-colors duration-200 font-medium text-left py-2 ${
                isActive('/services') ? 'text-[#0B7CB5]' : 'text-gray-700'
              }`}
            >
              Services
            </Link>
            <Link
              to="/calculator"
              onClick={() => setIsMobileMenuOpen(false)}
              className={`hover:text-[#0B7CB5] transition-colors duration-200 font-medium text-left py-2 ${
                isActive('/calculator') ? 'text-[#0B7CB5]' : 'text-gray-700'
              }`}
            >
              Estimate
            </Link>
            <Link
              to="/about"
              onClick={() => setIsMobileMenuOpen(false)}
              className={`hover:text-[#0B7CB5] transition-colors duration-200 font-medium text-left py-2 ${
                isActive('/about') ? 'text-[#0B7CB5]' : 'text-gray-700'
              }`}
            >
              About
            </Link>
            <Link
              to="/faq"
              onClick={() => setIsMobileMenuOpen(false)}
              className={`hover:text-[#0B7CB5] transition-colors duration-200 font-medium text-left py-2 ${
                isActive('/faq') ? 'text-[#0B7CB5]' : 'text-gray-700'
              }`}
            >
              FAQ
            </Link>
            <Link
              to="/careers"
              onClick={() => setIsMobileMenuOpen(false)}
              className={`hover:text-[#0B7CB5] transition-colors duration-200 font-medium text-left py-2 ${
                isActive('/careers') ? 'text-[#0B7CB5]' : 'text-gray-700'
              }`}
            >
              Careers
            </Link>
            <Link
              to="/policies"
              onClick={() => setIsMobileMenuOpen(false)}
              className={`hover:text-[#0B7CB5] transition-colors duration-200 font-medium text-left py-2 ${
                isActive('/policies') ? 'text-[#0B7CB5]' : 'text-gray-700'
              }`}
            >
              Policies
            </Link>
            <a 
              href="tel:+18045837000"
              onClick={() => setIsMobileMenuOpen(false)}
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-colors h-9 px-4 py-2 bg-[#0B7CB5] hover:bg-[#095a87] text-white w-full no-underline"
              style={{ touchAction: 'manipulation', cursor: 'pointer', WebkitTapHighlightColor: 'rgba(11, 124, 181, 0.3)', zIndex: 100 }}
            >
              Call/Text Us
            </a>
          </nav>
        )}
      </div>
    </header>
  );
};